<div class="snapshot-offscreen" aria-hidden="true">
  <kendo-pdf-export *ngIf="sections.length" #pdf paperSize="Letter"
                    [margin]="{ top: '0.6in', bottom: '0.6in', left: '0.6in', right: '0.6in' }"
                    keepTogether=".snapshot-row" [repeatHeaders]="false">
    <div class="snapshot">
      <h1>Hospital / SICF application snapshot</h1>
      <h2>{{ facilityName }}</h2>
      <p>Exported {{ generatedAt | date:'MMM d, y, h:mm a' }}</p>
      <p>Current application information. Blank fields are shown as “Not provided”.
        Uploaded documents are listed below; their contents are separate attachments.</p>
      <table *ngFor="let section of sections">
        <colgroup><col style="width: 43%"><col style="width: 57%"></colgroup>
        <thead><tr><th colspan="2">{{ section.title }}</th></tr></thead>
        <tbody>
          <tr class="snapshot-row" *ngFor="let row of section.rows">
            <td class="label">{{ row.label }}</td><td>{{ row.value }}</td>
          </tr>
          <tr *ngIf="!section.rows.length"><td colspan="2">None provided</td></tr>
        </tbody>
      </table>
    </div>
    <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <div class="snapshot-footer">Application snapshot · Page {{ pageNum }} of {{ totalPages }}</div>
    </ng-template>
  </kendo-pdf-export>
</div>
